import { useDataSource } from '@/src/renderer/lib/dataSource'

/** All tags, live, and a way to create one — from the data source (Dexie in the app). */
export function useTags() {
  const source = useDataSource()
  const tags = source.useTags()
  return { tags, createTag: source.createTag }
}
